(function ($, window, document, undefined) {
    // const $doc = $(document);
    // var $countDownTimer = $('.timer');
    // var year, month, day, hour, minutes, msgAfter, msgPattern;

    // year = parseInt($countDownTimer.data('year'));
    // month = parseInt($countDownTimer.data('month'));
    // day = parseInt($countDownTimer.data('day'));
    // hour = parseInt($countDownTimer.data('hour'));
    // minutes = parseInt($countDownTimer.data('minutes'));
    // msgAfter = $countDownTimer.data('msg-after');
    // msgPattern = $countDownTimer.data('msg-pattern');

    // var dateEnd = year + '/' + month + '/' + day + ' ' + hour + ':' + minutes;

    // console.log(dateEnd);

    // var countdown = new Countdown({
    //   selector: '.timer',
    //   msgBefore: '',
    //   msgAfter: msgAfter,
    //   msgPattern: msgPattern,
    //   dateStart: new Date(Date.now()),
    //   dateEnd: new Date(dateEnd)
    // });

    // $doc.ready(function() {
    //   console.log('document ready');
    // });
    // console.log('document ready');

    $('.upsell__product-checkbox input').on('change',function (){
        $(this).parent().parent().toggleClass('upsell__product--checked');
    });

})(jQuery, window, document);

(function($, window, document, undefined) {
    setTimeout(function() {
        $('.js-popup-play').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,

            fixedContentPos: false
        });
    }, 1500);

    if($('.section-simple-text').length) {
        $('.section-gallery').addClass('is-not-last');
    } else {
        $('.section-gallery').removeClass('is-not-last');
    }

})(jQuery, window, document);



// $(window).bind("pageshow", function() {
//   $('#add-engraving').prop("checked", false);
//   $('.product-personalizer').addClass('active');
// });


/*jslint sub: true, maxlen: 80, indent: 4 */

// ==ClosureCompiler==
// @output_file_name jquery.breakLines.min.js
// @compilation_level ADVANCED_OPTIMIZATIONS
// @code_url http://goo.gl/eL6PR
// ==/ClosureCompiler==

(function ($) {
    "use strict";

    // Written for: http://stackoverflow.com/questions/4671713/#7431801
    // by Nathan MacInnes, nathan@macinn.es

    // use square bracket notation for Closure Compiler
    $.fn['breakLines'] = function (options) {
        var defaults = {
            // HTML to insert before each new line
            'lineBreakHtml' : '<br>',
            // Set this to true to have the HTML inserted at the start of a
            // <p> or other block tag
            'atStartOfBlocks' : false,
            // false: <LINEBREAK><span>text</span>;
            // true: <span><LINEBREAK>text</span>
            'insideStartOfTags' : false,
            // If set, the element's size will be set to this before being
            // wrapped, then reset to its original value aftwerwards
            'widthToWrapTo' : false
        };
        options = $.extend(defaults, options);
        return this.each(function () {
            var textNodes, // all textNodes (as opposed to elements)
                copy, // jQuery object for copy of the current element
                el = $(this), // just so we know what we're working with
                recurseThroughNodes, // function to do the spitting/moving
                insertedBreaks, // jQuery collection of inserted line breaks
                styleAttr; // Backup of the element's style attribute

            // Backup the style attribute because we'll be changing it
            styleAttr = $(this).attr('style');

            // Make sure the height will actually change as content goes in
            el.css('height', 'auto');

            // If the user wants to wrap to a different width than the one
            // set by CSS
            if (options.widthToWrapTo !== false) {
                el.css('width', options.widthToWrapTo);
            }

            /*
                This function goes through each node in the copy and splits
                it up into words, then moves the words one-by-one to the
                element. If the node it encounters isn't a text node, it
                copies it to the element, then the function runs itself again,
                using the copy as the currentNode and the equivilent in the
                copy as the copyNode.
            */
            recurseThroughNodes = function (currentNode, copyNode) {
                $(copyNode).contents().each(function () {
                    var nextCopy,
                        currentHeight;

                    // update the height
                    currentHeight = el.height();

                    // If this is a text node
                    if (this.nodeType === 3) {
                        // move it to the original element
                        $(this).appendTo(currentNode);
                    } else {
                        // Make an empty copy and put it in the original,
                        // so we can copy text into it
                        nextCopy = $(this).clone().empty()
                            .appendTo(currentNode);
                        recurseThroughNodes(nextCopy, this);
                    }

                    // If the height has changed
                    if (el.height() !== currentHeight) {
                        // insert a line break and add to the list of
                        // line breaks
                        insertedBreaks = $(options.lineBreakHtml)
                            .insertBefore(this)
                            .add(insertedBreaks);
                    }
                });
            };

            // Clone the element and empty the original
            copy = el.clone().insertAfter(el);
            el.empty();

            // Get text nodes: .find gets all non-textNode elements, contents
            // gets all child nodes (inc textNodes) and the not() part removes
            // all non-textNodes.
            textNodes = copy.find('*').add(copy).contents()
                .not(copy.find('*'));

            // Split each textNode into individual textNodes, one for each
            // word
            textNodes.each(function (index, lastNode) {
                var startOfWord = /\W\b/,
                    result;
                while (startOfWord.exec(lastNode.nodeValue) !== null) {
                    result = startOfWord.exec(lastNode.nodeValue);
                    // startOfWord matches the character before the start of a
                    // word, so need to add 1.
                    lastNode = lastNode.splitText(result.index + 1);
                }
            });

            // Go through all the nodes, going recursively deeper, until we've
            // inserted line breaks in all the text nodes
            recurseThroughNodes(this, copy);

            // We don't need the copy anymore
            copy.remove();

            // Clean up breaks at start of tags as per options
            insertedBreaks.filter(':first-child').each(function () {
                if (!options.atStartOfBlocks &&
                    $(this).parent().css('display') === "block") {
                    $(this).remove();
                }
                if (!options.insideStartOfTags) {
                    $(this).insertBefore($(this).parent());
                }
            });
            // Restore backed-up style attribute
            $(this).attr('style', styleAttr);
        });
    };

    const $window = $(window);
    const $dropdownAlt = $('.js-dropdown-alt');

    if ($dropdownAlt.length > 0) {
        $dropdownAlt.each(function() {
            const $this = $(this);
            const $parent = $this.closest('li');
            $parent.addClass('has-dropdown js-has-dropdown');
            $parent.children(":first").addClass('js-dropdown-trigger');
        })

        $dropdownAlt.find('.js-close-dropdown').on('click', function() {
            const $this = $(this);
            $this.closest('.js-has-dropdown').removeClass('is-active');
            $this.closest('.js-header-nav').removeClass('overflow-hidden');
        })
    }

    const $hasDropdown = $('.js-has-dropdown');
//   $hasDropdown.on('click', function() {
//         if ($window.width() > 1023) {
//             $('.js-has-dropdown').removeClass('is-active');
//         }
//     });

    $hasDropdown.on('click', function() {
      if ($window.width() > 1023) {
        $('.js-has-dropdown').addClass('not-active');
        $(this).removeClass('not-active');
        $('.not-active').removeClass('is-active');
        $(this).toggleClass('is-active');
      }
    });

    $hasDropdown.on('mouseenter', function() {
        if ($window.width() > 1023) {
            $(this).addClass('hover-active');
        }
    });

    $hasDropdown.on('mouseleave', function() {
        if ($window.width() > 1023) {
            $(this).removeClass('hover-active');
        }
    });


  /*Scroll Navigation*/
//   $(window).on('scroll', function(){
//     if($(window).scrollTop() > 80 ){
//       $('.header-alt .header-alt__logo').css("width" : "30px");
//     }
//   });


//   function scrollEffectTwo(className) {
//     $(window).scroll(function() {
//       var scrollTop = $(window).scrollTop() + 210.98957824707031;
//       var header_banner = $(className).offset().top;
//       var header_scroll = className+" .banner-heading-effect";

//       if (scrollTop <= header_banner || $(window).scrollTop() == 0) {
//         $(header_scroll).css({"padding-bottom": "0px"});

//       } else if (scrollTop > header_banner) {
//         $(header_scroll ).css({"padding-bottom": ($(window).scrollTop() - header_banner )  + "px"});
//       }
//     });
//   }
//   $(document).ready(function() {
//     var lastScrollTop = 0;
//     var height =  $(".header-alt .header-alt__logo").height();
//     var oheight = height;
//     $(document).scroll(function() {
//       height=$(this).scrollTop()/($(document).height()-$(window).height())*oheight;
//       $(".header-alt .header-alt__logo").css({
//         'height': height
//       });
//     });
//   });
//   $(window).scroll(function () {

//     if ($(this).scrollTop() >= 50) {
//       var scrollTop = $(window).scrollTop();


//       $('.header-alt__utility>ul').css({
//         'margin': ''
//       });
//       $('.header-alt .header-alt__nav>ul>li>a').css({
//         'font-size': ''

//       })

//     } else{
//       $('.header-alt .header-alt__logo').css({
//         'width': ''
//       });
//       $('.header-alt__utility>ul').css({
//         'margin' : ''
//       });
//       $('.header-alt .header-alt__nav>ul>li>a').css({
//               'font-size': ''

//       })

//     }
//   });
  /*Scroll navigation*/

    $hasDropdown.find('.js-dropdown-trigger').on('click', function(event) {
        if ($window.width() <= 1023) {
        const $this = $(this);
        if ($this.hasClass('is-clicked')) {
            return;
        }

        event.preventDefault();
        $this.addClass('is-clicked');

        setTimeout(() => {
            if ($window.width() <= 1023) {
                $this.closest('.js-has-dropdown').addClass('is-active');
                $this.closest('.js-header-nav').addClass('overflow-hidden');
            }

            $this.removeClass('is-clicked')
        }, 200);
        }
    })

    const $headerContainer = $('.js-header-container');
    const $body = $('body');

    function updateBodyAccordionToHeader() {
        $body.css('padding-top', $headerContainer.outerHeight() + 'px');
    }

    if ($headerContainer.length > 0) {
        updateBodyAccordionToHeader();
    }

    let lastScrollTop = 0;
    const $headerBody = $('.js-header-body');
    let headerHeadHeight = $('.header-alt__head').outerHeight();
    let headerPromoHeight = $('.js-promo-banner').outerHeight();

    const $promoBanner = $('.js-promo-banner');

    $window.on('resize', function() {
        updateBodyAccordionToHeader();
        if ($window.width() < 1024) {
            headerHeadHeight = 0;
        }
    })

    if ($window.width() < 1024) {
        headerHeadHeight = 0;
    }

    if ($promoBanner.length > 0) {
        $promoBanner.find('.js-promo-close').on('click', function() {
            $(this).closest('.js-promo-banner').hide();
            updateBodyAccordionToHeader();
            document.documentElement.style.setProperty('--announce-height', '0px');
            headerPromoHeight = 0;
        })
    }
    
    let isMobile = window.matchMedia('(max-width: 768px)').matches;
    $window.on('resize', () => isMobile = window.matchMedia('(max-width: 768px)').matches);
    
    $window.on('scroll', function(event) {
        const currentScroll = $(this).scrollTop();
        if (currentScroll > lastScrollTop) {
            // downscroll code
            if(isMobile) {
                if (currentScroll > 0) {
                    $headerContainer.addClass('is-fixed');
                    document.documentElement.style.setProperty('--announce-height', '0px');
                }
                return;
            }
            if (currentScroll - (headerHeadHeight + headerPromoHeight) >= 3) {
                $headerContainer.addClass('is-fixed');
            }
        } else {
            // upscroll code
            if (currentScroll - (headerHeadHeight + headerPromoHeight) <= 3) {
                $headerContainer.removeClass('is-fixed');
                if(isMobile && $promoBanner.is(':visible')) {
                    document.documentElement.style.setProperty('--announce-height', '39px');
                }
            }
        }
        lastScrollTop = currentScroll;
        updateBodyAccordionToHeader();
    });

    const $burger = $('.js-burger-trigger');
    const $headerNav = $('.js-header-nav');
    const $hasDropDown = $headerNav.find('.js-has-dropdown')
    const $html = $('html');

    if ($headerNav.length > 0) {
        $headerNav.find('.js-close').on('click', function() {
            const $parentHeaderNav = $(this).closest('.js-header-nav');
            $parentHeaderNav.removeClass('is-active');
            $parentHeaderNav.removeClass('overflow-hidden');
            $body.removeClass('overflow-hidden');
            $burger.toggleClass('btn-burger--triggered');
            $hasDropDown.removeClass('is-active');
            $html.removeClass('overflow-hidden');
        })
    }

    /**
     * Handle Burger Trigger
     *
     * @param  {Event} event
     * @return {Void}
     */
    $burger.on('click', function(event) {
        event.preventDefault();

        const $this = $(this);
        const $headerContent = $this.closest('.js-header-alt').find('.js-header-nav');
        $this.toggleClass('btn-burger--triggered');
        $body.toggleClass('overflow-hidden');
        $headerContent.toggleClass('is-active');
        $hasDropDown.removeClass('is-active');
        $html.addClass('overflow-hidden');
    });

    /**
     * Stop Propagation.
     *
     * @return {Void}
     */
    $('.js-header-nav, .btn-burger, .js-search-dropdown, .js-search-dropdown-trigger').click(function(event) {
        event.stopPropagation();
    })

    const $searchDropdown = $('.js-search-dropdown');

    /**
     * Close on body.
     *
     * @return {Void}
     */
    $body.on('click', function() {
        if ($headerNav.hasClass('is-active')) {
            $body.removeClass('overflow-hidden');
            $headerNav.removeClass('is-active');
            $burger.toggleClass('btn-burger--triggered');
            $hasDropDown.removeClass('is-active');
        }

        if ($searchDropdown.hasClass('is-shown')) {
            $searchDropdown.removeClass('is-shown');
        }
    })

    //Search Tablet

    const $searchTriggerTablet = $('.js-tablet-trigger');

    if ($searchTriggerTablet.length > 0) {

        $searchTriggerTablet.on('click', function() {
            const $parent = $(this).closest('.js-parent');
            $parent.find('.js-search-dropdown').toggleClass('is-active');
            $body.addClass('overflow-hidden');
        })

        $searchTriggerTablet.each(function() {
            const $parent = $(this).closest('.js-parent');

            $parent.find('.js-close').on('click', function () {
                $(this).closest('.js-search-dropdown').removeClass('is-active');
                $body.removeClass('overflow-hidden');
            })
        })
    }

    const $searchDropdownTrigger = $('.js-search-dropdown-trigger');

    if ($searchDropdownTrigger.length) {
        $searchDropdownTrigger.on('click', function() {
            console.log('clicked');
            $(this).closest('.js-parent').find('.js-search-dropdown').toggleClass('is-shown');
        })
    }

    const $tabletAccordions = $('.js-tablet-accordion');

    if ($tabletAccordions.length > 0) {
        $tabletAccordions.each(function() {
            if ($window.width() < 1024) {
                const $parent = $(this);
                const $head = $parent.find('.js-tablet-accordion-head');
                const $body = $parent.find('.js-tablet-accordion-body');

                $body.slideUp();

                $head.on('click', function() {
                    const $this = $(this);
                    const $parent = $this.closest('.js-tablet-accordion');

                    $parent.toggleClass('is-active');
                    $parent.find('.js-tablet-accordion-body').slideToggle();
                })
            }
        })
    }

    // Homepage Video Modules
    let video = $('.homepage-video-hero video')[0];
    if (video != undefined)
    setTimeout(() => {
        video.style.display = 'block';
    }, "200")
    $(document).on('click', '.play-toggle',  function(){
        let video = $(this).parent().parent().find('video')[0];
        let controls = $(this).parent().find('.play-toggle')
        controls.toggleClass('hide');
        if (video.paused == true) {
            video.play();
        } else {
            video.pause();
        }
    });

    $(document).on('click', ' .sound-toggle',  function(){
        let video = $(this).parent().parent().find('video')[0];
        let controls = $(this).parent().find('.sound-toggle')
        controls.toggleClass('hide');
        if (video.muted == true) {
            video.muted = false;
        } else {
            video.muted = true;
        }
    });

}(jQuery));
